import { render, staticRenderFns } from "./GlobalRisk.vue?vue&type=template&id=d79e0330&lang=pug"
import script from "./GlobalRisk.vue?vue&type=script&lang=js"
export * from "./GlobalRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports